var exports = {
  "Q": "x61f99309--76c732--text",
  "S": "x61f99309--76c732--image",
};

module.exports = exports;
